const resource = {
    resource_identifier_in_use: '介面識別碼 {{indicator}} 已經被使用',
    cannot_delete_management_api: '無法刪除Logto管理介面。',
    cannot_modify_management_api: '無法修改Logto管理介面。',
};
export default Object.freeze(resource);
